export const isYYYYMM = s => typeof s === 'string' && /^\d{4}-\d{2}$/.test(s)
export const isWeekLabel = s => typeof s === 'string' && /^S\d+$/.test(s)
export const isDayMonth = s => typeof s === 'string' && /^\d{2}\/\d{2}$/.test(s)
const isPlainIntegerString = s => typeof s === 'string' && /^-?\d+$/.test(s.trim())
const isPlainDecimalString = s => typeof s === 'string' && /^-?\d+[.,]\d+$/.test(s.trim())
const isGroupedThousandsDot = s => typeof s === 'string' && /^-?[1-9]\d{0,2}(?:\.\d{3})+(?:,\d+)?$/.test(s.trim())
const isGroupedThousandsComma = s => typeof s === 'string' && /^-?[1-9]\d{0,2}(?:,\d{3})+(?:\.\d+)?$/.test(s.trim())

export const parseDisplayNumber = value => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0
  if (value == null) return 0
  if (typeof value !== 'string') {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : 0
  }

  const raw = value.trim()
  if (!raw) return 0

  const cleaned = raw.replace(/[^\d,.-]/g, '')
  if (!cleaned || cleaned === '-' || cleaned === ',' || cleaned === '.') return 0

  let normalized = cleaned
  const hasComma = cleaned.includes(',')
  const hasDot = cleaned.includes('.')
  const commaCount = (cleaned.match(/,/g) || []).length
  const dotCount = (cleaned.match(/\./g) || []).length

  if (!hasComma && isGroupedThousandsDot(cleaned)) {
    normalized = cleaned.replace(/\./g, '')
  } else if (!hasDot && isGroupedThousandsComma(cleaned)) {
    normalized = cleaned.replace(/,/g, '')
  } else if (hasComma && hasDot) {
    if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
      normalized = cleaned.replace(/\./g, '').replace(',', '.')
    } else {
      normalized = cleaned.replace(/,/g, '')
    }
  } else if (hasComma && commaCount >= 1) {
    normalized = cleaned.replace(/\./g, '').replace(',', '.')
  } else if (!hasComma && dotCount > 1) {
    normalized = cleaned.replace(/\./g, '')
  }

  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : 0
}

export const formatCLPFull = n => parseDisplayNumber(n).toLocaleString('es-CL')

export const formatCLP_M = n => {
  const value = parseDisplayNumber(n)
  if (Math.abs(value) < 1_000_000) return formatCLPFull(value)
  const compact = (value / 1_000_000).toLocaleString('es-CL', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })
  return `${compact}M`
}

export const EMPTY_GROUP_SUMMARY = {
  montoTotalGeneral: 0,
  cuentasAgrupadas: {},
}

export const getTopGroupedAccounts = group =>
  Object.entries(group?.cuentasAgrupadas || {})
    .map(([name, amount]) => ({ name, amount: Number(amount || 0) }))
    .sort((a, b) => b.amount - a.amount)
    .slice(0, 3)

export const formatDecimalDisplay = value =>
  parseDisplayNumber(value).toLocaleString('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })

export const formatBaseDisplayValue = value => {
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return '0'
    if (!Number.isInteger(value)) return formatDecimalDisplay(value)
    return formatCLPFull(value)
  }

  if (typeof value === 'string') {
    const raw = value.trim()
    if (!raw) return '0'
    if (isGroupedThousandsDot(raw) || isGroupedThousandsComma(raw)) return raw
    if (isPlainIntegerString(raw)) return formatCLPFull(raw)
    if (isPlainDecimalString(raw)) return formatDecimalDisplay(raw)
    return raw
  }

  if (value == null) return '0'
  const parsed = parseDisplayNumber(value)
  if (!Number.isFinite(parsed)) return '0'
  return Number.isInteger(parsed) ? formatCLPFull(parsed) : formatDecimalDisplay(parsed)
}

export const takeLastN = (arr, n) => (Array.isArray(arr) ? arr.slice(-Math.max(n, 1)) : [])
export const lowerVisibleCount = count => (count >= 12 ? 8 : count >= 8 ? 6 : count >= 6 ? 3 : count)
export const KPI_NUMBER_CLASS = 'whitespace-nowrap tabular-nums leading-none'

export const getMonthLabel = val => {
  if (val == null) return ''
  const s = typeof val === 'string' ? val : String(val)
  if (isWeekLabel(s) || isDayMonth(s)) return s

  if (isYYYYMM(s)) {
    const [y, m] = s.split('-')
    const dn = new Date(+y, +m - 1, 1)
    const name = dn.toLocaleString('es-ES', { month: 'long' })
    return name.charAt(0).toUpperCase() + name.slice(1)
  }

  const d = new Date(s)
  if (!isNaN(d)) {
    const name = d.toLocaleString('es-ES', { month: 'long' })
    return name.charAt(0).toUpperCase() + name.slice(1)
  }

  return String(s)
}
